import React from "react"
import { twMerge } from "tailwind-merge"

interface Props {
    color?: string
    className?: string
}

export function CoffeeIcon({ className, color = "#000" }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            fill={color}
            enableBackground="new 0 0 64 64"
            viewBox="0 0 64 64"
            className={twMerge("h-full w-full", className)}
        >
            <path d="M10.666 53.162a4.791 4.791 0 004.786 4.786h29.147a4.791 4.791 0 004.786-4.786v-1.035H10.666v1.035zM47.121 32.939h-.661c.074-.658.028-1.775.043-2.445a2.365 2.365 0 00-2.363-2.362H15.911a2.366 2.366 0 00-2.363 2.363v1.411c0 6.657 2.188 12.974 6.21 18.146h20.533a29.604 29.604 0 002.964-4.687h3.865c8.218-.29 8.227-12.133.001-12.426zm-24.38 11.637a1.038 1.038 0 01-1.447-.245 19.984 19.984 0 01-3.704-11.624c.022-1.361 2.052-1.367 2.076 0 0 3.756 1.148 7.36 3.321 10.422a1.038 1.038 0 01-.246 1.447zm24.38-1.287h-2.899a29.358 29.358 0 002.101-8.274c6.009-.575 6.78 7.895.798 8.274zM37.195 18.839a2.49 2.49 0 010 2.832l-2.037 2.932c-.768 1.109.921 2.301 1.705 1.184l2.037-2.932a4.574 4.574 0 00-.002-5.201l-2.563-3.683a2.478 2.478 0 01-.186-2.519l1.936-3.899c.587-1.223-1.231-2.14-1.859-.922L34.29 10.53a4.554 4.554 0 00.342 4.627l2.563 3.682zM30.527 20.281c.5.578.5 1.296.001 1.875l-2.038 2.361c-.59.636-.069 1.745.786 1.716.291 0 .581-.122.785-.36l2.038-2.361c1.167-1.352 1.166-3.239-.002-4.589l-2.564-2.966c-.439-.508-.5-1.11-.164-1.652l1.935-3.138c.695-1.167-1.031-2.242-1.768-1.088l-1.934 3.137c-.807 1.305-.665 2.915.361 4.1l2.564 2.965zM23.362 21.295c.322.416.322.933 0 1.349l-1.486 1.915c-.827 1.071.799 2.344 1.64 1.273l1.486-1.916a3.135 3.135 0 00-.001-3.894l-1.87-2.405a1.061 1.061 0 01-.103-1.193l1.411-2.546c.641-1.199-1.134-2.192-1.816-1.005l-1.411 2.546c-.62 1.121-.512 2.451.281 3.471l1.869 2.405z"></path>
        </svg>
    )
}
